import { SettingsParser } from "./settings-parser";
import { VisualizatorModeSettings } from "../settings/visualizator-mode-settings";

export class ModeSettingsParser extends SettingsParser {
  constructor(settingsParser) {
    super();
    this.parsedFieldNames = ["mode", "settings"];
    this.settingsParser = settingsParser;
  }

  static createSettings(settings, defaultSettings, settingsParser) {
    if (settings === undefined) {
      return undefined;
    }
    let parsedSettings = {
      mode: settings.mode
    };
    if (settings.settings !== undefined && settingsParser !== undefined) {
      parsedSettings.settings = settingsParser.parse(settings.settings, defaultSettings?.settings);
    }
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = ModeSettingsParser.createSettings(settings, defaultSettings, this.settingsParser);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new VisualizatorModeSettings(parsedSettings);
  }
}
